import RegistrationSetting from './RegistrationSetting';

export default RegistrationSetting;
